// Project-wide numeric display: de-DE separators (thousands ".", decimal ","),
// null/undefined → em dash (never blank, never "0"). See docs/gotchas.md § de-DE.
// Pass Intl options through for callers that need fraction digits etc.
export const formatNumber = (
  value: number | null | undefined,
  options?: Intl.NumberFormatOptions,
): string => (value == null ? "—" : value.toLocaleString("de-DE", options));
